import React from 'react';
import { Paragraph } from '@leafwell/components';
import ArrowButton from 'components/arrow-button';
import PageWrapMinimal from 'components/page-wrap-minimal';

const Custom500: React.FC = () => (
  <PageWrapMinimal title="An error occurred">
    <section className="grid gap-y-3 w-full max-w-sm text-center">
      <Paragraph variant="medium">We're working on fixing this.</Paragraph>
    </section>
    <ArrowButton
      {...{
        className: 'mt-6',
        title: 'Back to home',
        href: '/',
      }}
    />
  </PageWrapMinimal>
);

export default Custom500;
